export default __webpack_public_path__ + "static/media/success.ef25cf85.svg";